// src/i18n/locales/de/shoppingList.ts

export const shoppingList = {
  // Page Header
  title: 'Einkaufsliste',
  subtitle: 'Deine persönliche Einkaufsliste für diese Woche',
  daySubtitle: 'Einkaufsliste für Tag {{day}}',

  // Day section headers
  dayHeader: 'Tag {{day}}',
  dayHeaderUnassigned: 'Weitere Artikel',

  // View Mode Dropdown
  viewMode: {
    next7Days: 'Nächste 7 Tage',
    allItems: 'Alle Artikel',
  },

  // Subtitle Variations
  subtitleVariations: {
    default: 'Deine Zutaten für diesen Plan',
    daysRangeWithCount: 'Tag {{start}}–{{end}} anzeigen • {{count}} Artikel',
    allDays: 'Alle Tage anzeigen • {{count}} Artikel',
  },

  // Confirmation Messages
  confirmDeleteAll: 'Möchtest du wirklich alle Artikel aus der Einkaufsliste löschen?',

  // Mode Toggle (VIP only)
  modeToggle: {
    label: 'Einkaufsmodus',
    simpleList: 'Einfache Liste',
    smartShopping: 'Smart Shopping',
    locked: 'Smart Shopping wurde vom Administrator deaktiviert',
  },

  // Stats Cards
  stats: {
    totalItems: 'Artikel gesamt',
    completed: 'Erledigt',
    open: 'Offen',
    estimatedPrice: 'Geschätzter Gesamtpreis',
    items: 'Artikel',
    of: 'von',
  },

  // Action Buttons
  actions: {
    addProduct: 'Produkt hinzufügen',
    deleteCompleted: 'Erledigte löschen',
    deleteAll: 'Alle löschen',
    noCompleted: 'Keine erledigten Artikel',
    emptyList: 'Liste ist leer',
    exportPDF: 'PDF exportieren',
    completedCount: '{{count}} erledigte Artikel',
  },

  // Categories
  categories: {
    all: 'Alle Artikel',
    protein: 'Protein',
    meat: 'Fleisch',
    poultry: 'Geflügel',
    fish: 'Fisch',
    seafood: 'Meeresfrüchte',
    vegetables: 'Gemüse',
    fruits: 'Obst',
    dairy: 'Milchprodukte',
    grains: 'Getreide',
    bread: 'Brot & Backwaren',
    condiments: 'Gewürze & Saucen',
    snacks: 'Snacks',
    miscellaneous: 'Sonstiges',
    Protein: 'Protein',
    Vegetables: 'Gemüse',
    Dairy: 'Milchprodukte',
    Bread: 'Brot & Backwaren',
    Fruits: 'Obst',
    Grains: 'Getreide & Nudeln',
    Condiments: 'Gewürze & Saucen',
    Snacks: 'Snacks',
    Miscellaneous: 'Sonstiges',
  },

  // Item Card
  item: {
    approximately: 'ca.',
    estimated: 'geschätzt',
    buyNow: 'Jetzt kaufen',
    remove: 'Entfernen',
    edit: 'Bearbeiten',
  },

  // Add Item Modal
  addModal: {
    title: 'Produkt hinzufügen',
    subtitle: 'Füge einen neuen Artikel zur Einkaufsliste hinzu',

    fields: {
      name: {
        label: 'Produktname',
        placeholder: 'z. B. Bio-Haferflocken',
        required: 'Produktname ist erforderlich',
      },
      quantity: {
        label: 'Menge',
        placeholder: 'z. B. 500g oder 2 Stück',
        required: 'Menge ist erforderlich',
      },
      category: {
        label: 'Kategorie',
        placeholder: 'Kategorie auswählen',
      },
      price: {
        label: 'Geschätzter Preis (optional)',
        placeholder: 'z. B. 3.95',
      },
      supermarket: {
        label: 'Supermarkt (VIP)',
        placeholder: 'Supermarkt auswählen',
      },
    },

    supermarkets: {
      migros: 'Migros',
      coop: 'Coop',
      aldi: 'Aldi',
      denner: 'Denner',
      lidl: 'Lidl',
    },

    buttons: {
      cancel: 'Abbrechen',
      add: 'Zur Liste hinzufügen',
      adding: 'Wird hinzugefügt...',
    },
  },

  // Confirmation Modals
  confirmDelete: {
    completed: {
      title: 'Erledigte Artikel löschen?',
      message: '{{count}} erledigte(r) Artikel wird aus deiner Liste entfernt.',
      confirm: 'Ja, löschen',
      cancel: 'Abbrechen',
    },
    all: {
      title: 'Alle Artikel löschen?',
      message: 'Alle {{count}} Artikel werden unwiderruflich aus deiner Einkaufsliste entfernt.',
      confirm: 'Ja, alle löschen',
      cancel: 'Abbrechen',
    },
  },

  // Empty States
  empty: {
    title: 'Deine Einkaufsliste ist leer',
    titleDay: 'Keine Artikel für Tag {{day}}',
    titleDays: 'Keine Artikel für diese Tage',
    subtitle: 'Füge Artikel manuell oder aus Rezepten hinzu',
    addButton: 'Ersten Artikel hinzufügen',
    fromRecipe: 'Oder durchsuche Rezepte, um Zutaten hinzuzufügen',
  },

  // Toast Messages
  toast: {
    itemAdded: 'Artikel zur Einkaufsliste hinzugefügt',
    itemRemoved: 'Artikel entfernt',
    itemsCleared: '{{count}} Artikel entfernt',
    listCleared: 'Einkaufsliste geleert',
    quantityUpdated: 'Menge von {{name}} auf {{quantity}} aktualisiert',
    alreadyInList: 'Bereits in deiner Einkaufsliste',
    ingredientAdded: '{{name}} zur Einkaufsliste hinzugefügt',
    ingredientsAdded: '{{added}} Zutat(en) hinzugefügt, {{updated}} Mengen aktualisiert',
    allInList: 'Alle Zutaten befinden sich bereits in deiner Liste',
    errorAdding: 'Artikel konnte nicht hinzugefügt werden',
    errorRemoving: 'Artikel konnte nicht entfernt werden',
    errorLoading: 'Einkaufsliste konnte nicht geladen werden',
  },

  // Info Messages
  info: {
    simpleMode: 'Zeigt nur Produktnamen und Mengen mit geschätzten Preisen.',
    smartMode: 'Zeigt echte Produktkarten von Migros/Coop mit genauen Preisen und „Jetzt kaufen"-Buttons.',
    vipRequired: 'Der Smart-Shopping-Modus ist nur für VIP-Mitglieder verfügbar',
    adminDisabled: 'Smart Shopping wurde derzeit vom Administrator deaktiviert',
  },
};